module.exports = __webpack_public_path__ + "static/media/elon.56656737.jpg";